import apiConfig from "@config/api.json";
import { HttpStatusCode } from "axios";
import { inject, injectable } from "inversify";
import type { DateTime } from "luxon";
import MeasurementService from "@/src/application/services/measurement-service";
import type MeasurementResponse from "@/src/domain/models/measurement-response";
import type PaginatedFlowMeasurementResponse from "@/src/domain/models/paginated-flow-measurement-response";
import { MeasurementApi } from "@generated/n3-backend-api";
import { BusinessException } from "@/src/domain/common/business-exception";

@injectable()
export default class MeasurementServiceImpl extends MeasurementService {
  constructor(@inject(MeasurementApi) private readonly measurementApi: MeasurementApi) {
    super();
  }

  async fetchTotalFlowMeasurement(deviceId: number) {
    const res = await this.measurementApi.totalFlow(deviceId);
    return res.data;
  }

  async fetchPaginatedFlowMeasurements(
    deviceId: number,
    startDate: DateTime,
    endDate: DateTime,
    currentPage: number
  ): Promise<PaginatedFlowMeasurementResponse> {
    const res = await this.measurementApi.intervalFlowData(
      deviceId,
      startDate.toUTC().toISO()!,
      endDate.toUTC().toISO()!,
      apiConfig.request.defaultPageSize,
      currentPage
    );
    if (res.status != HttpStatusCode.Ok)
      throw new BusinessException("Failed to get interval flow measurement");
    return res.data;
  }
}
